export default __webpack_public_path__ + "static/media/welcome.94e396b6.png";